// https://observablehq.com/d/72217b40406a7dfe@576
import define1 from "./b39befcd04545d3a@65.js";

export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Tree map`
)});
  main.variable(observer()).define(["md"], function(md){return(
md`A tree map, with a legend, for area query data generated by Our Environment`
)});
  main.variable(observer("chart")).define("chart", ["width","d3","DOM","height","chartData","treemap","treedata","fmtAreaFn","blackOrWhite","Promises","viewof settings","settings","includeOther","html","hasUnclassified","legend"], function(width,d3,DOM,height,chartData,treemap,treedata,fmtAreaFn,blackOrWhite,Promises,$0,settings,includeOther,html,hasUnclassified,legend)
{
  const chartWidth = width * 0.8;
  let svg = d3.select(DOM.svg(chartWidth, height))
    .style('max-width', '100%')
    .attr('class', 'frag-tree-map')
    .attr('width', null)
    .attr('height', null); // the SVG DOM element will rescale to fit the viewBox height
 
  
  let total = d3.sum(chartData, d => d.value);
  
  const root = treemap(treedata);
  
  const leaf = svg.selectAll('g.leaf')
    .data(root.leaves())
    .enter()
    .append('g')
    .attr('class', 'leaf')
    .attr('transform', d => `translate(${d.x0},${d.y0})`) 
  leaf.append('title')
    .text(d => `${d.data.name} ${fmtAreaFn(d.data.value)}`);
  
  leaf.append('rect')
    .attr('id', d => (d.leafUid = DOM.uid("leaf")).id)
    .attr('fill', d=>d.data.color)
    .attr('stroke', d=>d.data.strokeColor)
    .style('stroke-opacity', 0.8)
    .attr('width', d=> d.x1 - d.x0)
    .attr('height', d=> d.y1 - d.y0);
  
  const text = leaf.append("text")
    .attr('fill', d => blackOrWhite(d.data.color));
  
  text.selectAll("tspan")
    .data(d => [d.data.name, fmtAreaFn(d.value)])
    .enter().append("tspan")
      .attr("x", 3)
      .attr("y", (d, i, nodes) => `${(i === nodes.length - 1) * 0.3 + 1.1 + i * 0.9}em`)
      .attr("fill-opacity", (d, i, nodes) => i === nodes.length - 1 ? 0.7 : null)
      .text(d => d);
  
  Promises.delay(0).then(async () => {
    const bbox = svg.node().getBoundingClientRect();
    let scale = chartWidth / bbox.width;
    if (!isFinite(scale)) { 
      scale = 1;
    }
      
    text.attr('transform',`scale(${scale})`);
    
    await Promises.delay(0, 'x');
    
    text.each(function(d) {
      const self = d3.select(this);
      const bbox = self.node().getBBox();
      self.style('visibility', bbox.width * scale > (d.x1 - d.x0)  || bbox.height * scale > (d.y1 - d.y0)  ? 'hidden' : null);
    });  
  }, 0);
  
  let updateSettings = (changedSettings) => {
    $0.value = Object.assign({}, settings, changedSettings);
  }
  
  let lowerControls = includeOther ? html`<div style='text-align: center;'/>` : '';
  if (hasUnclassified && includeOther) {
    d3.select(lowerControls)
      .append('label')
      .attr('class', 'no-print')
      .style('vertical-align', 'middle')
      .text('Show unclassified/other?  ')
      .append('input')
      .attr('type', 'checkbox')
      .property('checked', settings.includeOther)
      .on('change', function() {
        updateSettings({includeOther: !settings.includeOther})
        this.checked = settings.includeOther;
      });    
  }
  
  return html`<div style='display:flex;' class='d-block-xs'><div style='flex: 1 1; padding-right: 0.5em;'>${svg.node()}</div><div style='display: flex; flex-direction: column; justify-content: center; align-items: center; padding-left: 0.5em;'>${legend}</div></div>${lowerControls}`;
}
);
  const child1 = runtime.module(define1).derive(["chartData"], main);
  main.import("legend", child1);
  main.variable(observer("gis")).define("gis", ["require"], function(require){return(
require("@manaakiwhenua/frag-helper@0.0.7/dist/umd/gis-portals-transformers/index.js")
)});
  main.variable(observer("includeOther")).define("includeOther", function(){return(
true
)});
  main.variable(observer("hasUnclassified")).define("hasUnclassified", ["chartDataWithUnc"], function(chartDataWithUnc){return(
chartDataWithUnc.some(d => d.abbr == 'unc')
)});
  main.variable(observer("treemap")).define("treemap", ["d3","width","height","hierarchy"], function(d3,width,height,hierarchy){return(
data => d3.treemap()
  .size([width*0.8, height])
  .padding(1)
  .round(true)(hierarchy(data))
)});
  main.variable(observer("hierarchy")).define("hierarchy", ["d3"], function(d3){return(
(data) => {
  return d3.hierarchy(data, d=> d.values).sum(d => d.value || 0)
    .sort((a, b) => b.height - a.height || b.value - a.value)
}
)});
  main.variable(observer("treedata")).define("treedata", ["d3","chartData"], function(d3,chartData)
{
  const nest = d3.nest()
    .key(d => d.group)
    .entries(chartData);
  
  
  return {
    key: "layers",
    values: nest
  };
  // return nest
}
);
  main.variable(observer("fmtAreaFn")).define("fmtAreaFn", function(){return(
(m2) => {
  let hectares = m2/10000;
  
  if (hectares < 1) {
    return `< 1ha`;
  }
  return `${Math.round(hectares).toLocaleString()}ha`;
}
)});
  main.variable(observer("chartData")).define("chartData", ["includeOther","settings","chartDataWithUnc","chartDataNoUnc"], function(includeOther,settings,chartDataWithUnc,chartDataNoUnc){return(
includeOther && settings.includeOther ? chartDataWithUnc : chartDataNoUnc
)});
  main.variable(observer("chartDataWithUnc")).define("chartDataWithUnc", ["gis","rawData"], function(gis,rawData){return(
gis.AreaQuery.responseToGroupableTabularData(rawData, true)
)});
  main.variable(observer("chartDataNoUnc")).define("chartDataNoUnc", ["gis","rawData"], function(gis,rawData){return(
gis.AreaQuery.responseToGroupableTabularData(rawData, false)
)});
  main.variable(observer("colors")).define("colors", ["chartData"], function(chartData){return(
chartData.map(c => c.color)
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require('d3@5')
)});
  main.variable(observer("barHeight")).define("barHeight", function(){return(
50
)});
  main.variable(observer("barPadding")).define("barPadding", function(){return(
3
)});
  main.variable(observer("padding")).define("padding", function()
{
  return {
    top: 2,
    bottom: 2,
    left: 80,
    right: 50
  }
}
);
  main.variable(observer("height")).define("height", function(){return(
480
)});
  main.variable(observer("rawData")).define("rawData", function()
{
  return {"response":{"layers":[{"name":"wetlands_historic","raster":false,"rows":[{"columns":[{"name":"Class","value":"0"},{"name":"Class Description","value":"Bog (h)"},{"name":"Class Color","value":"#96825f"},{"name":"Class Area","value":1193385.2268798929},{"name":"Class Abbreviation","value":"hBog"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":1},{"columns":[{"name":"Class","value":"1"},{"name":"Class Description","value":"Fen (h)"},{"name":"Class Color","value":"#b4d264"},{"name":"Class Area","value":2.2564951721090887E7},{"name":"Class Abbreviation","value":"hFen"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":2},{"columns":[{"name":"Class","value":"4"},{"name":"Class Description","value":"Marsh (h)"},{"name":"Class Color","value":"#b4ffff"},{"name":"Class Area","value":1.063706836886548E8},{"name":"Class Abbreviation","value":"hMsh"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":3},{"columns":[{"name":"Class","value":"6"},{"name":"Class Description","value":"Seepage (h)"},{"name":"Class Color","value":"#96ff96"},{"name":"Class Area","value":502906.08583556855},{"name":"Class Abbreviation","value":"hSee"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":4},{"columns":[{"name":"Class","value":"7"},{"name":"Class Description","value":"Swamp (h)"},{"name":"Class Color","value":"#009600"},{"name":"Class Area","value":3.6707830513015294E8},{"name":"Class Abbreviation","value":"hSwp"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":5}]},{"name":"wetlands_current","raster":false,"rows":[{"columns":[{"name":"Class","value":"0"},{"name":"Class Description","value":"Bog (c)"},{"name":"Class Color","value":"#6e5a4b"},{"name":"Class Area","value":836520.5371468561},{"name":"Class Abbreviation","value":"cBog"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":1},{"columns":[{"name":"Class","value":"1"},{"name":"Class Description","value":"Fen (c)"},{"name":"Class Color","value":"#82a03c"},{"name":"Class Area","value":763947.1750264161},{"name":"Class Abbreviation","value":"cFen"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":2},{"columns":[{"name":"Class","value":"4"},{"name":"Class Description","value":"Marsh (c)"},{"name":"Class Color","value":"#82ffff"},{"name":"Class Area","value":1.0734850523575826E7},{"name":"Class Abbreviation","value":"cMsh"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":3},{"columns":[{"name":"Class","value":"6"},{"name":"Class Description","value":"Seepage (c)"},{"name":"Class Color","value":"#1eff1e"},{"name":"Class Area","value":446029.3938245664},{"name":"Class Abbreviation","value":"cSee"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":4},{"columns":[{"name":"Class","value":"7"},{"name":"Class Description","value":"Swamp (c)"},{"name":"Class Color","value":"#005000"},{"name":"Class Area","value":1.7461434136238296E7},{"name":"Class Abbreviation","value":"cSwp"},{"name":"Class Flags","value":3},{"name":"Class Flags Hash","value":{"SHOW_LONG_NAME_IN_CONTENTS":false,"HIDE_FROM_CONTENTS_PAGE":false,"VISUALISATION":true,"QUERY_ABLE":true}}],"number":5}]}],"pointHeight":0}
}
}
);
  main.variable(observer("color")).define("color", function(){return(
d => d.color
)});
  main.variable(observer("viewof settings")).define("viewof settings", ["View"], function(View){return(
new View({ fmt: 'ha', 'sort': 'Class', 'order': 'ASC', 'includeOther': true}, 'settings')
)});
  main.variable(observer("settings")).define("settings", ["Generators", "viewof settings"], (G, _) => G.input(_));
  main.variable(observer("View")).define("View", function(){return(
class View {
  constructor(value) {
    Object.defineProperties(this, {
      _list: {value: [], writable: true},
      _value: {value, writable: true}
    });
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
    this.dispatchEvent({type: "input", value});
  }
  addEventListener(type, listener) {
    if (type != "input" || this._list.includes(listener)) return;
    this._list = [listener].concat(this._list);
  }
  removeEventListener(type, listener) {
    if (type != "input") return;
    this._list = this._list.filter(l => l !== listener);
  }
  dispatchEvent(event) {
    const p = Promise.resolve(event);
    this._list.forEach(l => p.then(l));
  }
}
)});
  main.variable(observer("blackOrWhite")).define("blackOrWhite", ["d3"], function(d3){return(
(c) => {
  let rgb = d3.rgb(c);
  let [r,g,b] = [rgb.r, rgb.g, rgb.b]
    .map(c => c / 255.0)
    .map(c => c <= 0.03928 ? c/12.92 : Math.pow(((c+0.055)/1.055), 2.4));
  let l = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return l > 0.179 ? '#000000' : '#ffffff';
}
)});
  return main;
}
